import { tns } from 'tiny-slider/src/tiny-slider';
// import Alpine from 'alpinejs'
//
// window.Alpine = Alpine
// Alpine.start()

document.querySelectorAll('.lazyload').forEach(image => {
    if (image.type === 'image/webp') {
        image.srcset = image.dataset.src;
    } else {
        image.src = image.dataset.src;
    }

    image.classList.remove('lazyload');

    const parent = image.parentElement;
    if (parent.classList.contains('lazy-loader')) {
        parent.removeAttribute('class');
        parent.removeAttribute('style');
    }
});

let main = document.getElementById("body");
let body = document.getElementsByTagName("BODY")[0];

// ------------------------------------------------------------------------------------------------------------------ //

// MOBILE MENU
let menu = document.querySelector('.target-burger');
menu.onclick = function() {
    menu.classList.toggle('active');
    document.getElementById('mobile-navigation-links').classList.toggle('active')

    // Check if menu is open
    if (menu.classList.contains('active')) {
        // Don't allow body to be scrollable (nav is open)
        main.style.overflow = 'hidden';
        main.style.height = '0';
        body.style.overflow = 'overlay';
    } else {
        // Allow body to be scrollable again
        main.style.overflow = '';
        main.style.height = null;
        body.style.overflow = '';
    }
}

// ------------------------------------------------------------------------------------------------------------------ //

// CART
let cartButtons = document.querySelectorAll('.cart-nav-button');
for (let i = 0; i < cartButtons.length; i++) {
    (cartButtons[i]).onclick = function () {
        if (!main.classList.contains('hidden')) {
            // Don't allow body to be scrollable (nav is open)
            main.style.overflow = 'hidden';
            main.classList.toggle('hidden');
            body.style.overflow = 'overlay';
            document.getElementById('scroll-to-top').scrollIntoView()
        } else {
            // Allow body to be scrollable again
            closeCart();
        }
    };
}

// Setup listeners to close Cart on clicks outside the component
document.onclick = function(event) {
    if (event.target.id === 'body' && event.target.classList.contains('hidden')) {
        closeCart(true);
    }
};

(document.getElementById('close-cart-button')).onclick = function () {
    closeCart(true);
};

function closeCart(emitEvent = false) {
    main.style.overflow = '';
    main.classList.toggle('hidden');
    body.style.overflow = '';

    if (emitEvent) {
        // Close the Livewire component
        Livewire.dispatchTo('cart', 'toggleClass');
    }
}

// ------------------------------------------------------------------------------------------------------------------ //

// NUTRITION
let nutrition_blocks = document.querySelectorAll('section.nutrition')
for (let i = 0; i < nutrition_blocks.length; i++) {

    var paragraphs = (nutrition_blocks[i]).querySelectorAll('p')
    for (let k = 0; k < paragraphs.length; k++) {

        if (paragraphs[k].innerText === '') {
            (paragraphs[k]).style.padding = '10px 0'
        }
    }
}

// ------------------------------------------------------------------------------------------------------------------ //

// CAROUSEL
let carouselBlocks = document.querySelectorAll('.tiny-carousel');

if (carouselBlocks) {
    carouselBlocks.forEach(slider => {
        tns({
            container: slider,
            controlsText: ['<span>Previous Slider</span>', '<span>Next Slide</span>'],
            nav: false,
            items: 1,
            slideBy: 'page',
            autoplay: true,
            autoplayHoverPause: true,
            autoplayButton: false,
            autoplayButtonOutput: false,
            responsive: {
                800: {
                    items: 3
                },
                1024: {
                    items: 5
                }
            }
        });
    });
}

// ------------------------------------------------------------------------------------------------------------------ //

// VARIETY CAROUSEL
let varietyCarousel = document.querySelectorAll('.variety-carousel');

if (varietyCarousel) {
    varietyCarousel.forEach(slider => {
        tns({
            container: slider,
            controlsText: ['<span>Previous Slider</span>', '<span>Next Slide</span>'],
            nav: false,
            items: 1,
            responsive: {
                800: {
                    items: 2
                },
                1024: {
                    items: 3
                }
            }
        });
    });
}

// ------------------------------------------------------------------------------------------------------------------ //

// SLIDER
let tinySliderBlocks = document.querySelectorAll('.tiny-slider');

if (tinySliderBlocks) {
    tinySliderBlocks.forEach(slider => {
        tns({
            container: slider,
            controlsText: ['<span>Previous Slider</span>', '<span>Next Slide</span>'],
            navPosition: 'bottom',
            lazyload: true,
            autoHeight: true
        });
    });
}

// ------------------------------------------------------------------------------------------------------------------ //

// PHONE NUMBER FORMATTING

window.addEventListener('load', () => {
  const phoneInput = document.querySelector('#newsletter-subscribe-phone');
  phoneInput.addEventListener('keydown', disallowNonNumericInput);
  phoneInput.addEventListener('keyup', formatToPhone);
});

const disallowNonNumericInput = (evt) => {
  if (evt.ctrlKey) { return; }
  if (evt.key.length > 1) { return; }
  if (/[0-9.]/.test(evt.key)) { return; }
  evt.preventDefault();
}

const formatToPhone = (evt) => {
  const digits = evt.target.value.replace(/\D/g,'').substring(0,10);
  const areaCode = digits.substring(0,3);
  const prefix = digits.substring(3,6);
  const suffix = digits.substring(6,10);

  if(digits.length > 6) {evt.target.value = `${areaCode}-${prefix}-${suffix}`;}
  else if(digits.length > 3) {evt.target.value = `${areaCode}-${prefix}`;}
  else if(digits.length > 0) {evt.target.value = `${areaCode}`;}
};
